import React, { Component } from 'react';
import { connect } from 'react-redux';
import Task from './../task';
import AddTaskForm from './../addTaskForm';
import './mainPage.scss';

class MainPage extends Component {
    render() {
        let tasksList = this.props.tasks.map(task => {
            return (
                <Task key={task.id} settings={task}/>
            )
        });
        return (
            <div className='todo-container todo-frame'>
                <div className='todo-list'>
                    <div className='frame-header'>
                        <div className='frame-title'>Todo List</div>
                    </div>
                    <div className='list mt-1'>
                        {tasksList}
                    </div>
                </div>
                <AddTaskForm/>
            </div>
        )

    }
}

export default connect(
    state => ({
        tasks: state.tasksList
    }),
    null
)(MainPage);